import React from 'react'
import IntegrationCard from '@/features/integrations/components/IntegrationCard'
import { useSlackIntegration } from '../hooks/useSlackIntegration'
import type { IntegrationSummary } from '@/features/integrations/types'

const SlackLogo: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path d="M6.2 17.4a2.2 2.2 0 1 1-2.2-2.2h2.2v2.2ZM7.3 17.4a2.2 2.2 0 1 1 4.4 0v5.5a2.2 2.2 0 1 1-4.4 0v-5.5Z" fill="#E01E5A"/>
    <path d="M9.5 6.2a2.2 2.2 0 1 1 2.2-2.2v2.2H9.5ZM9.5 7.3a2.2 2.2 0 1 1 0 4.4H4a2.2 2.2 0 1 1 0-4.4h5.5Z" fill="#36C5F0"/>
    <path d="M20.7 9.5a2.2 2.2 0 1 1 2.2 2.2h-2.2V9.5ZM19.6 9.5a2.2 2.2 0 1 1-4.4 0V4a2.2 2.2 0 1 1 4.4 0v5.5Z" fill="#2EB67D"/>
    <path d="M17.4 20.7a2.2 2.2 0 1 1-2.2 2.2v-2.2h2.2ZM17.4 19.6a2.2 2.2 0 1 1 0-4.4H24a2.2 2.2 0 1 1 0 4.4h-6.6Z" fill="#ECB22E"/>
  </svg>
)

type Props = {
  workspaceId: string
  summary: IntegrationSummary | null
  onRefresh: () => void
}

const SlackIntegrationCard: React.FC<Props> = ({ workspaceId, summary, onRefresh }) => {
  const { actionStatus, errorMessage, connect, disconnect } = useSlackIntegration(workspaceId, summary, onRefresh)

  const handleDisconnect = async () => { await disconnect() }

  return (
    <IntegrationCard
      icon={<SlackLogo />}
      name="Slack"
      description="Respond to messages and receive tasks from Slack."
      status={summary?.status ?? 'not_configured'}
      connectedDetail={summary?.identifier ?? summary?.displayName}
      connecting={actionStatus === 'connecting'}
      disconnecting={actionStatus === 'disconnecting'}
      flash={actionStatus === 'error' ? 'error' : null}
      flashMessage={errorMessage ?? undefined}
      onConnect={connect}
      onDisconnect={handleDisconnect}
      onClearFlash={() => {}}
      connectLabel="Connect Workspace"
      disconnectConfirmTitle="Disconnect Slack"
      disconnectConfirmMessage={`Remove the Slack integration for ${summary?.displayName ?? 'this workspace'}? Zeph will stop responding to Slack messages immediately.`}
    />
  )
}

export default React.memo(SlackIntegrationCard)
